/**
 * 없는 화면. 영역 분리(260917-admin-area-split) 전 주소를 **경로만 보고** 한 번 옮긴다 — 역할을 보지 않는다.
 * `/app`·`/admin` 밖에서만 옮기므로 옮긴 곳이 또 없어도 루프가 없다. 공개 화면은 매치되므로 여기 오지 않는다.
 * 옛 주소가 더는 쓰이지 않으면 옮기는 분기를 지운다.
 */
import { Link, useLocation } from '@tanstack/react-router';
import { Redirect } from '../components/Redirect.tsx';
import { realmOfPath } from '../lib/paths.ts';

/** 운영자 전용이던 옛 경로 */
const LEGACY_ADMIN = /^\/(signups|agencies|users|sites|citations|workers|health|queries)\/?$/;
/** 질문 상세·샘플 상세는 운영자 영역에만 있다 — /app 으로 보내면 없는 화면이다 */
const LEGACY_ADMIN_DETAIL = /^\/(samples|queries)\//;

export function NotFound() {
  const location = useLocation();
  const inArea = /^\/(app|admin)(\/|$)/.test(location.pathname);
  if (!inArea) {
    const legacyAdmin = LEGACY_ADMIN.test(location.pathname) || LEGACY_ADMIN_DETAIL.test(location.pathname);
    const prefix = legacyAdmin ? '/admin' : '/app';
    const href = `${prefix}${location.pathname}${location.searchStr}`;
    return <Redirect key={href} go={(n) => n({ href, replace: true })} />;
  }
  return (
    <div className="rounded-md border border-slate-200 bg-white p-6 text-slate-600 text-sm">
      찾을 수 없는 화면입니다.{' '}
      <Link to={realmOfPath(location.pathname) === 'admin' ? '/admin' : '/app'} className="underline">
        처음으로
      </Link>
    </div>
  );
}
